import { Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { closeBonusModal, setInteracting } from "../../redux/slices/gift";
import { useNavigate } from "react-router";

function DepositGift() {
  const dispatch = useDispatch();
  const { openModal, loading } = useSelector((tate) => tate.gift);
  const navigate = useNavigate();

  const open = openModal === "deposit";

  const handleClose = () => dispatch(closeBonusModal());

  const submitted = () => {
    navigate("/wallet");
    handleClose();
    dispatch(setInteracting("deposit"));
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="relative max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl bg-black/80 animate-fadeIn">
          <img
            src="/images/deposit_bonus.jpg"
            alt="Popup background"
            className="w-full h-auto max-h-[90vh] object-contain pointer-events-none"
          />

          {/* Button */}
          <button
            className="absolute bottom-[8%] left-1/2 -translate-x-1/2 w-[40%] max-w-[200px] min-w-[120px]"
            type="button"
            disabled={loading}
            onClick={submitted}
          >
            {loading ? (
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <img
                src="/images/btn1.png"
                alt="Submit button"
                className="w-full h-auto object-contain"
              />
            )}
          </button>

          {/* Close button */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 z-20 text-white bg-white/20 hover:bg-white/30 rounded-full w-9 h-9 flex items-center justify-center text-xl font-bold"
            aria-label="Close popup"
          >
            ×
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DepositGift;
